var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.98745,
    height: 16.3228,
    transform: "matrix(0.999571 0.0292908 -0.13544 0.990786 2.89453 0.511719)",
    fill: "#C10037"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.98745,
    height: 16.3228,
    transform: "matrix(0.999571 0.0292908 -0.13544 0.990786 10.8789 0.746094)",
    fill: "#C10037",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.4578,
    height: 16.3228,
    transform: "matrix(0.999571 0.0292908 -0.13544 0.990786 18.8633 0.980469)",
    fill: "#C10037",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.619aeb7dace42af9b65c713b8bf7c55d.svg";
export { ForwardRef as ReactComponent };